import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { REMOVE_APP_INSTALLATION_RESOURCE, APP_INSTALLATIONS_RESOURCE } from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

const RemoveAppInstallationService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_APP_INSTALLATION_RESOURCE,
      method: 'delete',
      request: (appId, appInstallationId, callback, t) => ({
        url: apiRoutes.appInstallationsDetail(appId, appInstallationId),
        meta: {
          callback,
          removeFromOtherList: {
            resource: APP_INSTALLATIONS_RESOURCE,
            idProp: 'id',
            listPath: 'appInstallations',
            id: appInstallationId,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeAppInstallationFailed'),
            onSuccessMessage: t('removeAppInstallationSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RemoveAppInstallationService;
